import React from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';

const RHFAutocomplete = ({
                             control,
                             name,
                             options,
                             label,
                             getOptionLabel,
                             onAfterChange,
                             className,
                             disabled,
                             rules,
                             isOptionEqualToValue,
                         }) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
            <Autocomplete
                options={options}
                getOptionLabel={getOptionLabel}
                isOptionEqualToValue={isOptionEqualToValue}
                value={field.value || null}
                onChange={(_, newValue) => {
                    field.onChange(newValue);
                    if (onAfterChange) onAfterChange(newValue);
                }}
                onBlur={field.onBlur}
                disabled={disabled}
                className={className}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        error={!!error}
                        helperText={error?.message}
                    />
                )}
            />
        )}
    />
);

export default RHFAutocomplete;